export default __webpack_public_path__ + "static/media/RevenueRecaptureRight.ccb71aa0.png";